  <div class="layout-create-root">
    <div class="layout-create-body" [class.layout-create-body--no-sidebar]="hideNavSidebar">
      @if (!hideNavSidebar) {
        <kzn-sidebar-create #sidebarRef [class.mobile-open]="sidebarMobileOpen" (menuItemClick)="closeMobileSidebar()"></kzn-sidebar-create>
      }
      <div class="layout-create-right">
        <kzn-header-create
          [showSidebarToggle]="!hideNavSidebar"
          (toggleSidebar)="onToggleSidebar()"
          (toggleKapybara)="onToggleKapybara()"></kzn-header-create>
        <div class="layout-create-page" [class.layout-create-page--field-editor]="hideNavSidebar">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <kzn-footer-create></kzn-footer-create>

    <!-- Mobile sidebar backdrop - outside click to close drawer -->
    <div class="sidebar-mobile-backdrop" [class.show]="sidebarMobileOpen" (click)="closeMobileSidebar()"></div>

    <!-- Kapybara Sidebar Drawer -->
    <div class="kapybara-backdrop" [class.show]="kapybaraSidebarOpen" (click)="closeKapybara()"></div>
    <aside class="kapybara-drawer" [class.show]="kapybaraSidebarOpen">
      <div class="kapybara-drawer__header">
        <div class="kapybara-drawer__header-left">
          <div class="kapybara-drawer__avatar-wrap">
            <img src="assets/kapybara.png" alt="Kapybara" class="kapybara-drawer__avatar" />
          </div>
          <div>
            <h3 class="kapybara-drawer__name">Kapybara Assistant</h3>
            <span class="kapybara-drawer__tagline">HERE TO HELP!</span>
          </div>
        </div>
        <button type="button" class="kapybara-drawer__close" (click)="closeKapybara()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="kapybara-drawer__content">
        <div class="kapybara-drawer__scroll">
          <!-- Collapsible Sections -->
          <details class="kapybara-drawer__section" [attr.open]="showGettingStarted ? '' : null">
            <summary (click)="showGettingStarted = !showGettingStarted; $event.preventDefault()">
              <mat-icon>description</mat-icon>
              <span>Getting Started</span>
              <mat-icon class="kapybara-drawer__chevron">{{ showGettingStarted ? 'expand_less' : 'expand_more' }}</mat-icon>
            </summary>
            <div class="kapybara-drawer__section-body">
              <p>Create signature requests, manage templates, and track document status from your dashboard.</p>
            </div>
          </details>

          <details class="kapybara-drawer__section" [attr.open]="showQuickTipsSection ? '' : null">
            <summary (click)="showQuickTipsSection = !showQuickTipsSection; $event.preventDefault()">
              <mat-icon>auto_awesome</mat-icon>
              <span>Quick Tips</span>
              <mat-icon class="kapybara-drawer__chevron">{{ showQuickTipsSection ? 'expand_less' : 'expand_more' }}</mat-icon>
            </summary>
            <div class="kapybara-drawer__section-body">
              <ul class="kapybara-drawer__tips-list">
                <li>Use templates to speed up recurring documents</li>
                <li>Add multiple signers for collaborative signing</li>
                <li>Track status from the Requests page</li>
              </ul>
            </div>
          </details>

          <details class="kapybara-drawer__section" [attr.open]="showHelpSection ? '' : null">
            <summary (click)="showHelpSection = !showHelpSection; $event.preventDefault()">
              <mat-icon>help_outline</mat-icon>
              <span>Help & FAQ</span>
              <mat-icon class="kapybara-drawer__chevron">{{ showHelpSection ? 'expand_less' : 'expand_more' }}</mat-icon>
            </summary>
            <div class="kapybara-drawer__section-body">
              <p>Need assistance? Visit our help center or contact support for any questions.</p>
            </div>
          </details>

          <!-- Welcome Message -->
          <div class="kapybara-drawer__welcome">
            <div class="kapybara-drawer__msg">
              <img src="assets/kapybara.png" alt="" class="kapybara-drawer__msg-avatar" />
              <div class="kapybara-drawer__bubble">
                <p>Welcome! I'm Kapybara, your document signing assistant. How can I help you today?</p>
                <div class="kapybara-drawer__msg-actions">
                  <button mat-stroked-button color="primary" class="kapybara-drawer__action-btn" (click)="handleAssistantAction('startTour')">
                    <mat-icon>flag</mat-icon> Start Tour
                  </button>
                  <button mat-stroked-button class="kapybara-drawer__action-btn" (click)="handleAssistantAction('quickTips')">
                    <mat-icon>tips_and_updates</mat-icon> Quick Tips
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Assistant Response -->
          @if (assistantResponseLoading) {
          <div class="kapybara-drawer__response-shimmer">
            <div class="kapybara-drawer__shimmer-line"></div>
            <div class="kapybara-drawer__shimmer-line"></div>
            <div class="kapybara-drawer__shimmer-line kapybara-drawer__shimmer-line--short"></div>
          </div>
          } @else if (assistantResponseText) {
          <div class="kapybara-drawer__response">
            <img src="assets/kapybara.png" alt="" class="kapybara-drawer__msg-avatar" />
            <div class="kapybara-drawer__bubble">
              <p>{{ assistantResponseText }}</p>
            </div>
          </div>
          }
        </div>

      </div>
    </aside>

  </div>

